import { MOCK_CONFLUENCE_COLLECT } from './mock_confluence_collect';
import { MOCK_CONFLUENCE_SMART_LINK_TEST } from './mock_confluence_smart_link_test';
import { MOCK_CYPHER_RESULT } from './mock_cypher_result';
import { MOCK_ENTITIES_RESULT } from './mock_entities_result';
import { MOCK_EXTERNALIZED_CONFLUENCE_PAGE } from './mock_externalized_confluence_page';
import { MOCK_EXTERNALIZED_RESULT } from './mock_externalized_result';
import { MOCK_SCALAR_CYPHER_RESULT } from './mock_scalar_cypher_result';
import { MOCK_STAGING_POLLINATOR } from './mock_staging_pollinator';
import { MOCK_TOWNSQUARE } from './mock_townsquare';

export const MOCKS = {
	'mock-cypher-result': {
		name: 'Standard cypher result',
		data: MOCK_CYPHER_RESULT as Record<string, any>,
	},
	'mock-scalar-cypher-result': {
		name: 'Scalar cypher result',
		data: MOCK_SCALAR_CYPHER_RESULT as Record<string, any>,
	},
	'mock-entities-result': {
		name: 'Entities result',
		data: MOCK_ENTITIES_RESULT as Record<string, any>,
	},
	'staging-pollinator': {
		name: 'Staging pollinator',
		data: MOCK_STAGING_POLLINATOR as Record<string, any>,
	},
	'confluence-smart-link-test': {
		name: 'Confluence smart link test',
		data: MOCK_CONFLUENCE_SMART_LINK_TEST as Record<string, any>,
	},
	'confluence-collect': {
		name: 'confluence collect',
		data: MOCK_CONFLUENCE_COLLECT as Record<string, any>,
	},
	'townsquare-mock': {
		name: 'townsquare mock',
		data: MOCK_TOWNSQUARE as Record<string, any>,
	},
	'externalized-result': {
		name: 'Externalized result',
		data: MOCK_EXTERNALIZED_RESULT as Record<string, any>,
	},
	'externalized-confluence-page': {
		name: 'Externalized confluence page',
		data: MOCK_EXTERNALIZED_CONFLUENCE_PAGE as Record<string, any>,
	},
};

export type MockKey = keyof typeof MOCKS | 'none';
